import { AssistantRuntimeProvider } from '@assistant-ui/react';
import useAssistantChatController from 'hooks/chat/useAssistantChatController';
import { createContext, useContext } from 'react';

const ChatRuntimeContext = createContext(null);

const useChatRuntime = () => useContext(ChatRuntimeContext);

const AssistantChatRuntime = ({
    buildOutgoingRequest,
    children,
    chat,
    fileKey,
    isConnected,
    onChatRequestStateChange,
    onMessage,
    sendMessage,
    threadListAdapter,
}) => {
    const { chatRuntimeContextValue, runtime } = useAssistantChatController({
        buildOutgoingRequest,
        chat,
        fileKey,
        isConnected,
        onChatRequestStateChange,
        onMessage,
        sendMessage,
        threadListAdapter,
    });
    return (
        <ChatRuntimeContext.Provider value={chatRuntimeContextValue}>
            <AssistantRuntimeProvider runtime={runtime}>{children}</AssistantRuntimeProvider>
        </ChatRuntimeContext.Provider>
    );
};

export { useChatRuntime };
export default AssistantChatRuntime;
